import styles from './styles.module.scss'

import { Card, Button, Input } from 'antd';

import { useContext, useState } from 'react';

import { UserContext } from '@/context/user';
import { setUserContextItem, removeUserContextItem } from '@/persistence/user_context';

export const UniversalAnalyticsAttribute = ({ onDone }: AttributeInput) => {
  const { uaAttr, setUaAttr } = useContext(UserContext)
  const [value, setValue] = useState<string>('')

  const onInputChange = (e: any) => {
    setValue(e.target.value)
  }

  const onReset = () => {
    removeUserContextItem({ key: 'ua_id' })
    setUaAttr(undefined)
  }

  const onSet = () => {
    const validateResult = onValidate(value)

    if (!validateResult) {
      alert('입력한 유니버설 아이디가 바르지 않습니다. 다시 확인해주세요')
      return
    }

    setUserContextItem({ key: 'ua_id', value })
    setUaAttr({ id: value })

    if (onDone) { onDone() }
  }

  const onTest = () => {
    window.gtag('event', 'test', {
      hello: 'world'
    });
  }

  /**
   * UA 아이디 샘플 UA-54516992-1
   */
   const onValidate = (attribute: string) => {
    const lowerAttr = attribute.toLowerCase()

    if (!lowerAttr.startsWith('ua-')){
      return false
    }

    return true
  }

  const headStyle = {
    backgroundColor: '#fff1f0'
  }

  const bodyMinHeightStyle = {
    minHeight: '160px'
  }

  const bodyStyle = {
    backgroundColor: '#fff1f0',
    ...bodyMinHeightStyle,
  }

  return (
    <Card
      title="유니버설 애널리틱스 ID"
      headStyle={!uaAttr ? headStyle : {}}
      bodyStyle={!uaAttr ? bodyStyle : bodyMinHeightStyle }
      bordered={true}>
      {
        (uaAttr && uaAttr.id) && (
          <>
            <div className={styles.rowInput}>
              <Input size="large" value={uaAttr.id} disabled={true} />
            </div>
            <div className={styles.rowButton}>
              <Button type="dashed" danger onClick={(e) => onReset() }>초기화하기</Button>
              <Button style={{ marginLeft: '14px' }}type="primary" onClick={(e) => onTest() }>테스트</Button>
            </div>
          </>
        )
      }
      {
        (!uaAttr || !uaAttr.id) && (
          <>
            <div className={styles.rowInput}>
              <Input size="large" placeholder="유니버설 애널리틱스 ID를 입력해주세요" onChange={(e) => onInputChange(e) } />
            </div>
            <div className={styles.rowButton}>
              <Button type="primary" onClick={(e) => onSet() }>설정하기</Button>
            </div>
          </>
        )
      }
    </Card>
  )
}
